"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RBI_ERROR_LOG = void 0;
exports.RBI_ERROR_LOG = '[rbi.rbi_error] Exception';
//# sourceMappingURL=rbi-error-2.const.js.map